import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SidebarService } from './sidebar.service';
import { DataService } from 'src/app/Common/data.service';
import { AppTokenHandler } from 'src/app/Common/app-token-handler';
// import { MenusService } from './menus.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('slide', [
      state('up', style({ height: 0 })),
      state('down', style({ height: '*' })),
      transition('up <=> down', animate(200))
    ])
  ]
})
export class SidebarComponent implements OnInit {
  menus: any;
  favoriteMenu: any;
  IsShowFavorite: any = 0;


  constructor(private appToken: AppTokenHandler, public sidebarservice: SidebarService, public _dataservice: DataService) {
    // this.menus = sidebarservice.getMenuList();


  }

  ngOnInit() {
    this.GetMenuList();
    this.GetFavoriteMenuList();
  }

  GetMenuList() {
    if (this.appToken.getSessionForMenu() == null) {
      this._dataservice.GetData('FillCommonData/GetMenuList/').subscribe(result => {
        this.menus = result;
        this.appToken.setSessionForMenu(this.menus);
        console.log(this.menus);
      });
    }
    else {
      this.menus = this.appToken.getSessionForMenu();
    }
  }

  GetFavoriteMenuList() {
    this._dataservice.GetData('FillCommonData/GetFavoriteMenuList/').subscribe(result => {
      this.favoriteMenu = result;
    });
  }
  getSideBarState() {
    return this.sidebarservice.getSidebarState();
  }

  toggle(currentMenu) {
    if (currentMenu.type === 'dropdown') {
      this.menus.forEach(element => {
        if (element === currentMenu) {
          currentMenu.active = !currentMenu.active;
        } else {
          element.active = false;
        }
      });
    }
  }
  AddToFavorite(menuID) {
    this._dataservice.PostData('FillCommonData/AddToFavorite', { Param1: menuID }).subscribe(result => {
      this._dataservice.GetData('FillCommonData/GetMenuList/').subscribe(result => {
        this.menus = result;
        this.appToken.setSessionForMenu(this.menus);
        this.GetFavoriteMenuList();
      });
    })
  }

  ToggleMenuList(ItemID) {
    this.IsShowFavorite = ItemID;
  }

  getState(currentMenu) {

    if (currentMenu.active) {
      return 'down';
    } else {
      return 'up';
    }
  }

  hasBackgroundImage() {
    return this.sidebarservice.hasBackgroundImage;
  }

}
